module.exports = __webpack_public_path__ + "img/fuel-insight-start.2cd9d05a.svg";